module.exports = __webpack_public_path__ + "assets/souverenty-big.1ae111d0.svg";